import { OverallHealth } from '../../types/enums';

import logo from './logo.png';

import styles from './DashboardFooter.module.scss';

export interface DashboardFooterProps {
  healthInfo?: {
    [key in OverallHealth]?: number;
  };
}

const DashboardFooter = ({ healthInfo = {} }: DashboardFooterProps) => {
  const count = Object.values(healthInfo).reduce((acc, curr) => acc + curr, 0);

  return (
    <div className={styles.wrapper}>
      {healthInfo && (
        <div className={styles.status}>
          <div className={styles.visual}>
            Account Status:
            <div className={styles.ticks}>
              {Object.entries(healthInfo).map(([key, value]) => {
                if (value === 0) {
                  return null;
                }

                const tickCount = count > 20 ? Math.ceil(20 * (value / count)) : value;

                return new Array(tickCount)
                  .fill(null)
                  .map((_, index) => <span key={index} data-status={key} />);
              })}
            </div>
            {Math.floor((100 * (healthInfo[OverallHealth.OK] ?? 0)) / count)}%
          </div>
          <div className={styles.labels}>
            {Object.entries(healthInfo).map(([key, value]) => {
              if (value === 0) {
                return null;
              }

              return (
                <div key={key}>
                  {labels[key as OverallHealth]}
                  <span>{value}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <img src={logo} />
    </div>
  );
};

const labels = {
  [OverallHealth.ERROR]: <span className={styles.error}>Error:</span>,
  [OverallHealth.WARNING]: <span className={styles.warning}>Warning:</span>,
  [OverallHealth.OK]: <span className={styles.ok}>Ok:</span>,
  [OverallHealth.UNKNOWN]: <span className={styles.loading}>Loading:</span>,
  [OverallHealth.UNAVAILABLE]: <span className={styles.unavailable}>Unavailable:</span>
};

export default DashboardFooter;
